(function($) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function(partial) {

        var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

})(jQuery);
let is_mobile = screen.width < 776 ;
if(window.is_welcome_page){
    $(document).ready( ()=>{
        highLightAnimate(true);
    })
    $(window).scroll(function(event) {
        highLightAnimate(true);
        whatWeDoAnimate(true);
    });
        if(is_mobile){
            highLightSmAnimate(true);
        }
}


function highLightAnimate(partial){
    $(".phone").each(function(i, el) {
        var el = $(el);
        if (el.visible(partial)) {
            el.addClass("come-in");
            setTimeout(()=>{
                el.addClass('animate-float')
            },800)
        }
    });
    var el = $(".text-section");
        if (el.visible(partial)) {
            el.addClass("slide-in");
        }
}

function whatWeDoAnimate(partial){
    $(".what-we-do-box").each(function(i, el) {
        var el = $(el);
        let tm = 100   * i;
        if (el.visible(partial)) {
           setTimeout(()=>{
               el.addClass("come-in");
           },tm)
        }
    });
}

function highLightSmAnimate(partial){
    let el  = $('.phones');
    if (el.visible(partial)) {
        el.addClass("come-in-fast");
    }
}

